import dayjs from 'dayjs';
import { Call } from '@/types/call';
import { UnitFeedItem } from '@/types/unit-feed-item';
import { Response } from '@/types/wellbeing-response';

export const buildUnitFeedItems = (
  responses: Response[],
  calls: Call[],
): UnitFeedItem[] => {
  const responseItems = responses.flatMap<UnitFeedItem>((response) => {
    if (response.type === 'responseNotification') {
      return [
        {
          kind: 'notification',
          response,
          timestamp: response.sendTimeStamp,
        },
      ];
    }

    if (response.type === 'wellbeingCheck') {
      return [
        {
          kind: 'wellbeing',
          response,
          timestamp: response.sendTimeStamp,
        },
      ];
    }

    return [];
  });

  const callItems: UnitFeedItem[] = calls.map((call) => ({
    call,
    kind: 'call',
    timestamp: call.placedAt,
  }));

  return [...responseItems, ...callItems].sort(
    (a, b) => dayjs(b.timestamp).valueOf() - dayjs(a.timestamp).valueOf(),
  );
};
